/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SuiviReassignmentDto
 */
export interface SuiviReassignmentDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof SuiviReassignmentDto
     */
    idssuivi?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviReassignmentDto
     */
    idrealisateurSuivi?: number;
}

/**
 * Check if a given object implements the SuiviReassignmentDto interface.
 */
export function instanceOfSuiviReassignmentDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuiviReassignmentDtoFromJSON(json: any): SuiviReassignmentDto {
    return SuiviReassignmentDtoFromJSONTyped(json, false);
}

export function SuiviReassignmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuiviReassignmentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idssuivi': !exists(json, 'idssuivi') ? undefined : json['idssuivi'],
        'idrealisateurSuivi': !exists(json, 'idrealisateurSuivi') ? undefined : json['idrealisateurSuivi'],
    };
}

export function SuiviReassignmentDtoToJSON(value?: SuiviReassignmentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idssuivi': value.idssuivi,
        'idrealisateurSuivi': value.idrealisateurSuivi,
    };
}

